import React, { useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faSync,
  faLaptop,
  faDrawPolygon,
} from "@fortawesome/free-solid-svg-icons";
import { ThemeContext } from "../../../context/ThemeContext";
import "../../../pages/Landing/LandingPage.css";

const Features = () => {
  const { darkMode } = useContext(ThemeContext);

  return (
    <section
      className={`advanced-features-section py-5 ${
        darkMode ? "dark-mode" : ""
      }`}
      id="features"
    >
      <div className="container">
        <div className="row text-center mb-5">
          <div className="col-12">
            <h2 className="advanced-features-title">Advanced Features</h2>
            <p className="advanced-features-subtitle">
              Discover powerful capabilities designed to elevate your accounting
              experience
            </p>
          </div>
        </div>
        <div className="row g-3 g-md-4 justify-content-center">
          <div className="col-6 col-lg-3 col-md-6">
            <div className="feature-card">
              <div className="feature-card-content">
                <div className="feature-icon-wrapper">
                  <FontAwesomeIcon icon={faEdit} className="feature-icon" />
                </div>
                <h5 className="feature-title">Product Management</h5>
                <p className="feature-description">
                  Create and manage your product catalog with detailed
                  categorization, pricing, and inventory tracking.
                </p>
              </div>
              <div className="feature-card-glass"></div>
            </div>
          </div>
          <div className="col-6 col-lg-3 col-md-6">
            <div className="feature-card">
              <div className="feature-card-content">
                <div className="feature-icon-wrapper">
                  <FontAwesomeIcon icon={faSync} className="feature-icon" />
                </div>
                <h5 className="feature-title">Ledger Management</h5>
                <p className="feature-description">
                  Maintain comprehensive financial records with our automated
                  ledger system that tracks all transactions.
                </p>
              </div>
              <div className="feature-card-glass"></div>
            </div>
          </div>
          <div className="col-6 col-lg-3 col-md-6">
            <div className="feature-card">
              <div className="feature-card-content">
                <div className="feature-icon-wrapper">
                  <FontAwesomeIcon icon={faLaptop} className="feature-icon" />
                </div>
                <h5 className="feature-title">User Access Control</h5>
                <p className="feature-description">
                  Set granular user permissions and roles to ensure each team
                  member has appropriate access.
                </p>
              </div>
              <div className="feature-card-glass"></div>
            </div>
          </div>
          <div className="col-6 col-lg-3 col-md-6">
            <div className="feature-card">
              <div className="feature-card-content">
                <div className="feature-icon-wrapper">
                  <FontAwesomeIcon
                    icon={faDrawPolygon}
                    className="feature-icon"
                  />
                </div>
                <h5 className="feature-title">Data Export & Analysis</h5>
                <p className="feature-description">
                  Export reports to Excel or PDF format for further analysis or
                  presentation to stakeholders.
                </p>
              </div>
              <div className="feature-card-glass"></div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .advanced-features-section {
          padding: 80px 0;
          background-color: ${darkMode ? "#1e1e1e" : "#fff"};
          position: relative;
          overflow: hidden;
        }

        /* Explicitly remove the pseudo-elements */
        .advanced-features-section::before,
        .advanced-features-section::after {
          display: none;
        }

        .advanced-features-title {
          font-size: 36px;
          font-weight: 700;
          color: ${darkMode ? "#f5f5f5" : "#333"};
          margin-bottom: 15px;
        }

        .advanced-features-subtitle {
          color: ${darkMode ? "#cccccc" : "#666"};
          max-width: 700px;
          margin: 0 auto;
        }

        .feature-card {
          position: relative;
          height: 320px;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 6px 15px rgba(0, 0, 0, 0.1);
          transition: all 0.4s ease;
          cursor: pointer;
          background-color: ${darkMode ? "#2d2d2d" : "white"};
          margin-bottom: 20px;
        }

        .feature-card:hover {
          transform: translateY(-10px);
          box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
        }

        .feature-card:hover .feature-card-glass {
          opacity: 1;
        }

        .feature-card:hover .feature-title {
          color: ${darkMode ? "#fff" : "#000"};
        }

        .feature-card:hover .feature-description {
          color: ${darkMode ? "#ddd" : "#222"};
        }

        .feature-card:hover .feature-icon {
          color: #4ade80;
          transform: scale(1.15);
        }

        .feature-card-content {
          position: relative;
          z-index: 2;
          height: 100%;
          width: 100%;
          padding: 30px 20px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-align: center;
          transition: all 0.3s ease;
        }

        .feature-card-glass {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(
            135deg,
            rgba(255, 255, 255, 0.25),
            rgba(255, 255, 255, 0.1)
          );
          backdrop-filter: blur(10px);
          -webkit-backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.18);
          border-radius: 12px;
          opacity: 0;
          transition: all 0.5s ease;
          z-index: 1;
        }

        .feature-icon-wrapper {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 80px;
          height: 80px;
          border-radius: 50%;
          background-color: rgba(0, 211, 137, 0.1);
          margin-bottom: 25px;
          transition: all 0.3s ease;
          position: relative;
        }

        .feature-card:hover .feature-icon-wrapper {
          background-color: rgba(74, 222, 128, 0.1);
          transform: rotate(5deg);
        }
           .feature-icons {
          font-size: 35px;
          color: #00d389;
          transition: all 0.3s ease;
      }

        .feature-icon {
          font-size: 35px;
          color: #00d389;
          transition: all 0.3s ease;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          line-height: 1;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .feature-title {
          font-size: 20px;
          font-weight: 600;
          color: ${darkMode ? "#f5f5f5" : "#333"};
          margin-bottom: 15px;
          transition: all 0.3s ease;
        }

        .feature-description {
          font-size: 15px;
          color: ${darkMode ? "#aaa" : "#666"};
          transition: all 0.3s ease;
        }

        /* Mobile-specific optimizations */
        @media (max-width: 767.98px) {
          .advanced-features-section {
            padding: 40px 0;
          }

          .advanced-features-title {
            font-size: 28px;
            margin-bottom: 12px;
          }

          .advanced-features-subtitle {
            font-size: 16px;
          }

          .feature-card {
            height: 280px;
            margin-bottom: 15px;
          }

          .feature-card-content {
            padding: 20px 15px;
          }

          .feature-icon-wrapper {
            width: 60px;
            height: 60px;
            margin-bottom: 20px;
          }

          .feature-icon {
            font-size: 28px;
          }

          .feature-title {
            font-size: 16px;
            margin-bottom: 12px;
          }

          .feature-description {
            font-size: 13px;
            line-height: 1.4;
          }

          /* Reduce gap between cards on mobile */
          .row.g-3.g-md-4 {
            --bs-gutter-x: 0.75rem;
            --bs-gutter-y: 0.75rem;
          }
        }

        /* Small mobile devices */
        @media (max-width: 575.98px) {
          .feature-card {
            height: 260px;
          }

          .feature-card-content {
            padding: 18px 12px;
          }

          .feature-icon-wrapper {
            width: 55px;
            height: 55px;
            margin-bottom: 18px;
          }

          .feature-icon {
            font-size: 25px;
          }

          .feature-title {
            font-size: 15px;
            margin-bottom: 10px;
          }

          .feature-description {
            font-size: 12px;
          }
        }
      `}</style>
    </section>
  );
};

export default Features;
